<template>
  <transition name="sheet">
    <div v-if="show" class="overlay" @click.self="close">
      <form class="sheet" role="dialog" aria-modal="true" :aria-label="$t('sec_password')" @submit.prevent="confirm">
        <div class="head">
          <h3>{{ $t('sec_password') }}</h3>
          <button type="button" class="close" :aria-label="$t('cancel')" @click="close">
            <span class="material-symbols-outlined">close</span>
          </button>
        </div>
        <p class="hint">{{ $t('sec_password_hint') }}</p>
        <label class="field">
          <span class="material-symbols-outlined">lock</span>
          <input ref="input" v-model="password" :type="visible ? 'text' : 'password'" autocomplete="off"
            :placeholder="$t('sec_password_placeholder')">
          <button type="button" class="eye" @click="visible = !visible">
            <span class="material-symbols-outlined">{{ visible ? 'visibility_off' : 'visibility' }}</span>
          </button>
        </label>
        <button class="btn-gold block" type="submit" :disabled="!password">{{ $t('confirm') }}</button>
      </form>
    </div>
  </transition>
</template>

<script>
// Same contract as web2: $bus.$emit('open-sec-modal', { type }) -> $bus.$emit('sec-passed-<type>', password)
export default {
  data() {
    return { show: false, type: '', password: '', visible: false };
  },
  created() {
    this.$bus.$on('open-sec-modal', this.open);
  },
  beforeDestroy() {
    this.$bus.$off('open-sec-modal', this.open);
  },
  methods: {
    open({ type }) {
      this.type = type;
      this.password = '';
      this.visible = false;
      this.show = true;
      this.$nextTick(() => this.$refs.input && this.$refs.input.focus());
    },
    close() {
      this.show = false;
    },
    confirm() {
      if (!this.password) return;
      this.$bus.$emit(`sec-passed-${this.type}`, this.password);
      this.password = '';
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.sheet {
  width: 100%;
  max-width: var(--page-max);
  padding: 20px 16px calc(24px + env(safe-area-inset-bottom));
  border-radius: 24px 24px 0 0;
  background: rgba(14, 18, 26, 0.96);
  border: 1px solid rgba(255, 229, 143, 0.35);
  border-bottom: 0;
  box-shadow: 0 -20px 60px -12px rgba(0, 0, 0, 0.9), 0 0 30px -5px rgba(212, 175, 55, 0.12);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;

  h3 {
    margin: 0;
    font-family: var(--font-display);
    font-size: 20px;
    font-weight: 600;
  }
}

.close {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--outline);
}

.hint {
  margin: -8px 0 0;
  color: var(--on-surface-variant);
  font-size: 13px;
}

.field {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 52px;
  padding: 0 12px;
  border-radius: var(--r-md);
  background: #121620;
  border: 1px solid rgba(121, 134, 156, 0.2);
  transition: border-color 0.15s, box-shadow 0.15s;

  &:focus-within {
    border-color: var(--gold);
    box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.15);
  }

  > .material-symbols-outlined { color: var(--outline); }

  input {
    flex: 1;
    min-width: 0;
    height: 100%;
    background: transparent;
    border: 0;
    outline: none;
    font-size: 16px;
  }
}

.eye { color: var(--outline); display: inline-flex; }

.sheet-enter-active,
.sheet-leave-active { transition: opacity 0.2s; }
.sheet-enter-active .sheet,
.sheet-leave-active .sheet { transition: transform 0.25s ease; }
.sheet-enter,
.sheet-leave-to { opacity: 0; }
.sheet-enter .sheet,
.sheet-leave-to .sheet { transform: translateY(40px); }
</style>
